export default __webpack_public_path__ + "static/media/Mock Up Screen.5c31c021.png";